_ = require 'underscore'
t = require('app/scripts/views/internal/teacup-with-helpers')()
View = require 'app/scripts/views/internal/view'
xtend = require 'xtend'

template = t.renderable ({ icon, name, text, type }) ->
  if icon?
    t.icon icon, { class: "mod-quiet" }
  t.span '.badge-text', ->
    if name && type != 'checkbox'
      t.text "#{name}: #{text}"
    else
      t.text text

colorClasses =
  'black': 'field-color-black'
  'blue': 'field-color-blue'
  'green': 'field-color-green'
  'orange': 'field-color-orange'
  'red': 'field-color-red'
  'yellow': 'field-color-yellow'
  'purple': 'field-color-purple'
  'pink': 'field-color-pink'
  'sky': 'field-color-sky'
  'lime': 'field-color-lime'
  'light-gray': 'field-color-light-gray'

module.exports = class CustomFieldBadgeView extends View
  tagName: 'div'
  className: ->
    colorClass = @getColorClass()
    if colorClass
      "badge field-color #{colorClass}"
    else
      'badge'

  initialize: ({ @customFieldItem, @customField }) ->

  getColorClass: ->
    colorClasses[@options.customFieldItem?.getColor()]

  renderBadge: (badge) ->
    @$el.html(template(badge))
    @$el

  render: ->
    customField = @customField.toJSON()
    customFieldItem = @customFieldItem.toJSON()

    icon = if @customField.get('type') == 'checkbox' then @customField.icon()
    text = @customFieldItem.getFrontBadgeText()

    $badge = @renderBadge(xtend(customFieldItem, _.pick(customField, 'name', 'type'), { icon, text }))

    @
